import React from 'react'
import { FaRegFilePdf } from "react-icons/fa6";

function Downloads() {
    return (
        <section className="sevenScopeSec pb-5 mb-5">
            <div className="container-fluid">
                <span className="contact__shape-1"></span>
                <div className="sliderInrHdng" style={{ position: "static" }}>
                    <h2>Downloads <span className="hdngBrkr"></span></h2>
                </div>
                <div className="Downloadbox mt-5">
                    <div className="row">
                        <div className="radiobtnsdiv">
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    All
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    Open File
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    English
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    Telugu
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    Tamil
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    Malayalam
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    Hindi
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    Kannada
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    Gujarati
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    Bengali
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    Assamese
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    Nepali
                                </label>
                            </div>
                            {/* <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    Odia
                                </label>
                            </div> */}
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                <label className="form-check-label" for="flexRadioDefault1">
                                    Urdu
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="downloadpdfsdiv ">
                        <div className="row mt-4">
                            <div className="col-3">
                                <div className="pdfdiv">
                                    <div className="pdficn">
                                        <FaRegFilePdf />
                                        <span>Download Now</span>
                                    </div>
                                    <div className="pdfcnt">
                                        <p className="pdfcntheading">Save Energy</p>
                                        <p className="pdfcntcontent">Use LED Bulbs Tube-Lights (Open File)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="pdfdiv">
                                    <div className="pdficn">
                                        <FaRegFilePdf />
                                        <span>Download Now</span>
                                    </div>
                                    <div className="pdfcnt">
                                        <p className="pdfcntheading">Save Energy</p>
                                        <p className="pdfcntcontent">Use LED Bulbs Tube-Lights (Open File)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="pdfdiv">
                                    <div className="pdficn">
                                        <FaRegFilePdf />
                                        <span>Download Now</span>
                                    </div>
                                    <div className="pdfcnt">
                                        <p className="pdfcntheading">Save Energy</p>
                                        <p className="pdfcntcontent">Use LED Bulbs Tube-Lights (Open File)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="pdfdiv">
                                    <div className="pdficn">
                                        <FaRegFilePdf />
                                        <span>Download Now</span>
                                    </div>
                                    <div className="pdfcnt">
                                        <p className="pdfcntheading">Save Energy</p>
                                        <p className="pdfcntcontent">Use LED Bulbs Tube-Lights (Open File)</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-3">
                                <div className="pdfdiv">
                                    <div className="pdficn">
                                        <FaRegFilePdf />
                                        <span>Download Now</span>
                                    </div>
                                    <div className="pdfcnt">
                                        <p className="pdfcntheading">Save Energy</p>
                                        <p className="pdfcntcontent">Use LED Bulbs Tube-Lights (Open File)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="pdfdiv">
                                    <div className="pdficn">
                                        <FaRegFilePdf />
                                        <span>Download Now</span>
                                    </div>
                                    <div className="pdfcnt">
                                        <p className="pdfcntheading">Save Energy</p>
                                        <p className="pdfcntcontent">Use LED Bulbs Tube-Lights (Open File)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="pdfdiv">
                                    <div className="pdficn">
                                        <FaRegFilePdf />
                                        <span>Download Now</span>
                                    </div>
                                    <div className="pdfcnt">
                                        <p className="pdfcntheading">Save Energy</p>
                                        <p className="pdfcntcontent">Use LED Bulbs Tube-Lights (Open File)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="pdfdiv">
                                    <div className="pdficn">
                                        <FaRegFilePdf />
                                        <span>Download Now</span>
                                    </div>
                                    <div className="pdfcnt">
                                        <p className="pdfcntheading">Save Energy</p>
                                        <p className="pdfcntcontent">Use LED Bulbs Tube-Lights (Open File)</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-3">
                                <div className="pdfdiv">
                                    <div className="pdficn">
                                        <FaRegFilePdf />
                                        <span>Download Now</span>
                                    </div>
                                    <div className="pdfcnt">
                                        <p className="pdfcntheading">Save Energy</p>
                                        <p className="pdfcntcontent">Use LED Bulbs Tube-Lights (Open File)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="pdfdiv">
                                    <div className="pdficn">
                                        <FaRegFilePdf />
                                        <span>Download Now</span>
                                    </div>
                                    <div className="pdfcnt">
                                        <p className="pdfcntheading">Save Energy</p>
                                        <p className="pdfcntcontent">Use LED Bulbs Tube-Lights (Open File)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="pdfdiv">
                                    <div className="pdficn">
                                        <FaRegFilePdf />
                                        <span>Download Now</span>
                                    </div>
                                    <div className="pdfcnt">
                                        <p className="pdfcntheading">Save Energy</p>
                                        <p className="pdfcntcontent">Use LED Bulbs Tube-Lights (Open File)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="pdfdiv">
                                    <div className="pdficn">
                                        <FaRegFilePdf />
                                        <span>Download Now</span>
                                    </div>
                                    <div className="pdfcnt">
                                        <p className="pdfcntheading">Save Energy</p>
                                        <p className="pdfcntcontent">Use LED Bulbs Tube-Lights (Open File)</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Downloads